<template>
  <div class="modal-card">
    <!-- main body -->
    <section v-if="step == 'main'" class="modal-card-body">
      <button
        @click="individual()"
        class="download-report-button is-flex has-text-white has-background-warning is-full"
      >
        <b-icon icon="file-pdf" size="is-medium"> </b-icon>
        <span>
          <h3 class="has-text-white">Individual 360 Reports</h3>
          <p class="small has-text-white">
            Produce 360 Reports for this project
          </p>
        </span>
      </button>
      <button
        @click="management()"
        class="download-report-button is-flex has-text-white has-background-warning is-full"
      >
        <b-icon icon="file-pdf" size="is-medium"> </b-icon>
        <span>
          <h3 class="has-text-white">Management Overview Report</h3>
          <p class="small has-text-white">
            A management overview showing themes
          </p>
        </span>
      </button>
      <a
        v-for="(report, index) in reports"
        :key="index"
        :href="route(report.route, project.unique_id)"
        :target="report.route == 'reports.bulkThreeSixtyReport' ? '' : _blank"
      >
        <button
          class="download-report-button is-flex has-text-white has-background-warning is-full"
        >
          <b-icon :icon="report.icon" size="is-medium"> </b-icon>
          <span>
            <h3 class="has-text-white">{{ report.name }}</h3>
            <p class="small has-text-white">
              {{ report.description }}
            </p>
          </span>
        </button>
      </a>
    </section>

    <!-- 360 reports -->
    <section
      v-if="step == 'individual'"
      class="modal-card-body individual-selector"
    >
      <p class="back" @click="step = 'main'">Back</p>
      <table>
        <tr v-for="user in users" :key="user.uuid">
          <td>{{ user.first_name }} {{ user.last_name }}</td>
          <td>
            <a
              target="_BLANK"
              :href="
                route('reports.threeSixtyReport', [
                  project.unique_id,
                  user.unique_id,
                ])
              "
              >View</a
            >
          </td>
        </tr>
      </table>
    </section>

    <!-- management overview reports -->
    <section
      v-if="step == 'management'"
      class="modal-card has-background-white"
    >
      <div class="modal-card-body">
        <b-button
          class="mb-3"
          label="Back"
          icon-left="arrow-left"
          @click="step = 'main'"
        />
        <b-table
          :data="tags"
          :columns="columns"
          :checked-rows.sync="selectedTags"
          checkable
        >
          <template #bottom-left>
            <b>Total checked</b>: {{ selectedTags.length }}
          </template>
        </b-table>
      </div>
      <div class="modal-card-foot">
        <b-button
          label="Confirm"
          @click.prevent="generateManagementReport"
          type="is-success"
        />
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    project: { type: Object },
  },
  data() {
    const reports = [
      {
        name: 'Bulk PDF Reports',
        description: 'Produce 360 Reports for this project',
        icon: 'file-pdf',
        route: 'reports.bulkThreeSixtyReport',
      },
      {
        name: 'Tutors Report',
        description:
          'A detailed report show progress for each particiapnt and feedback giver',
        icon: 'file-pdf',
        route: 'reports.tutorsReport',
      },
      {
        name: 'Progress Report',
        description: 'A summary report showing progress by participant',
        icon: 'file-pdf',
        route: 'reports.progressReport',
      },
      {
        name: 'Manual Email Report',
        description: 'Identifies Feedback Givers who need chasing',
        icon: 'file-pdf',
        route: 'reports.manualEmailReport',
      },
    ];
    return {
      reports,
      step: 'main',
      users: null,
      tags: null,
      selectedTags: [],
      columns: [{ field: 'name', label: 'Participant Groupings' }],
    };
  },
  methods: {
    individual: function () {
      fetch(route('projects.apiGetUsers', this.project.unique_id))
        .then((response) => response.json())
        .then((data) => {
          this.users = data;
        });
      this.step = 'individual';
    },
    management: function () {
      fetch(route('projects.apiGetTags', this.project.unique_id))
        .then((response) => response.json())
        .then((data) => {
          if (!data.length > 0) {
            window.open(
              route('reports.managementReport', this.project.unique_id)
            );
            return;
          }
          this.tags = this.selectedTags = data;
          this.step = 'management';
        });
    },
    generateManagementReport: function () {
      let tags = this.selectedTags
        .map((a) => 'tags[]=' + a.unique_id + '&')
        .join('');
      window.open(
        route('reports.managementReport', this.project.unique_id) + '?' + tags
      );
    },
  },
};
</script>
